enum StatusCode {
    C001 = "C001",
    C002 = "C002"
}

export default StatusCode